// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__34Oe1","content":"styles_content__Pzn1X","checkbox":"styles_checkbox__1uHU0","checkboxLabel":"styles_checkboxLabel__3qvrH"};